<template>
    <div class="flex-box" style="padding: 10px 5px">
        <span class="pager-btn-page pager-prev hand" :class="{'pager-disabled':prevDisable}" @click="jumpPrev()">{{$t('prev_page')}}</span>
        <template v-for="(i,idx) in pageSize">
            <span v-if="i==pageNo" class="pager-btn-page curr" :key="idx">{{i}}</span>
            <span class="pager-btn-page hand" :key="idx" v-else-if="pageSize<7||i==1||i==pageSize||(pageNo-1<=i&&i<=pageNo+1)" @click="jump(i)">
                {{i}}
            </span>
        </template>
        <span class="pager-btn-page pager-next hand" :class="{'pager-disabled':nextDisable}" @click="jumpNext()">{{$t('next_page')}}</span>
        <div class="mg-left15 mg-right5">{{$t('one_page_line')}}</div>
        <div class="width-50"><el-input class="pager-limit-input" number :maxlength="2" v-model="limit_curr" @keyup.enter.native="limitChange" /></div>
        <div class="flex-box-bd"></div>
        <slot></slot>
    </div>
</template>


<script>
    export default {
        name: "pager",
        model:{ //通过v-model传过来的参数
            prop: 'pageNo',
            event: 'jumpPage'
        },
        props:{
            limit:{
                type:[Number,String],
                default: 10
            },
            pageSize:{
                type: Number,
                default: 1
            },
            pageNo:{ //通过v-model传过来的参数
                type: Number,
                default: 1
            }
        },
        data(){
            return {
                limit_curr: this.limit
            }
        },
        computed: {
            prevDisable: function(){ //“上一页”按钮是否可点
                if(this.pageNo > 1){
                    return false;
                }else{
                    return true
                }
            },
            nextDisable: function(){ //“下一页”按钮是否可点
                if(this.pageNo < this.pageSize && this.pageSize > 1){
                    return false;
                }else{
                    return true;
                }
            },
        },
        methods: {
            jumpPrev: function () { //点击上一页
                if (this.pageNo == 1) {
                    return;
                } else {
                    this.$emit('jumpPage', this.pageNo - 1);
                    this.$emit('onPagerChange', this.pageNo - 1);
                }
            },
            jumpNext: function () { //点击下一页
                if (this.pageNo == this.pageSize) {
                    return;
                } else {
                    this.$emit('jumpPage', this.pageNo + 1); //修改当前页码
                    this.$emit('onPagerChange', this.pageNo + 1); //跳转
                }
            },
            jump: function (id) { //直接跳转
                if (id > this.pageSize) {
                    id = this.pageSize;
                }
                this.$emit('jumpPage', id); //修改当前页码
                this.$emit('onPagerChange', id); //跳转
            },
            limitChange: function () {
                this.$emit('jumpPage', 1);
                this.$emit('onLimitChange', this.limit_curr);
            }
        }
    }
</script>

<style scoped>
    .pager-btn-page{
        border:solid 1px #e5e5e5;
        display: inline-block;
        width: 30px;
        height:30px;
        line-height:30px;
        text-align: center;
        margin: 0 5px;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
    }
    .pager-btn-page.curr{
        color: #fff;
        border:solid 1px #007dff;
        background-color: #007dff;
    }
    .pager-btn-page.pager-prev{
        width: auto;
        padding: 0 20px;
        margin-left: 0;
    }
    .pager-btn-page.pager-next{
        width: auto;
        padding: 0 20px;
        margin-right: 0;
    }
    .pager-btn-page.pager-next:not(.pager-disabled):active{
        background-color: #ececec;
    }
    .pager-btn-page.pager-disabled{
        background-color: #f4f4f4;
        color: #888;
    }
</style>



// WEBPACK FOOTER //
// src/components/myPager.vue